/* eslint-disable @typescript-eslint/unbound-method */
import { Component, Inject, PLATFORM_ID, type OnInit } from '@angular/core';
import { type MatDatepicker } from '@angular/material/datepicker';
import { NotificationComponent } from '../../../../shared/components/notification/notification.component';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from '../../../../shared/services/util.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { type FormGroup, FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CalendarService } from '../../../../shared/services/calendar.service';
import { addDays, format } from 'date-fns';
import { MatError, MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { isPlatformBrowser } from '@angular/common';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StorageService } from '../../../../shared/services/storage.service';
import { StorageEnum } from '../../../../shared/enums/storage.enum';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { NotificationsService } from '../../../../shared/services/notifications.service';
import { NotificationType } from '../../../../shared/enums/notificationtype.enum';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CmsService } from '../../../../shared/services/cms.service';
import { SsmStepperComponent } from '../../../../shared/components/ssm-stepper/ssm-stepper.component';
import { SafePipe } from '../../../../shared/pipes/dom-sanitizer.pipe';
import { SsmSidePanelComponent } from '../../../../shared/components/ssm-side-panel/ssm-side-panel.component';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SSMProcessData, StartServiceRequest } from '../../../../shared/models/start-service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { Router, RouterModule } from '@angular/router';
import { PageHeaderComponent } from '../../../../shared/components/page-header/page-header.component';
import { PageHeader } from '../../../../shared/models/page-header.model';
import { Nav } from '../../../../shared/enums/nav.enum';
import { UserProfile } from '../../../../shared/models/user-profile';
import { ServiceAddress } from '../../../../shared/models/service-address';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { SeoService } from '../../../../shared/services/seo.service';
import { emailValidator } from '../../../../shared/validators/email.validator';
import { EmailInfo } from '../../../../shared/models/email-info';
import { AccountDetail } from '../../../../shared/models/account-detail';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { AccountService } from '../../../../shared/services/account.service';
import { EmailFormComponent } from '../../../../shared/components/email-form/email-form.component';
import { concatMap, type Observable, of } from 'rxjs';

@Component({
  selector: 'app-schedule-service',
  imports: [
    NotificationComponent,
    ReactiveFormsModule,
    MatRadioModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDividerModule,
    MatCheckboxModule,
    MatError,
    SsmStepperComponent,
    SafePipe,
    SsmSidePanelComponent,
    MatSelectModule,
    MatTooltipModule,
    PageHeaderComponent,
    EmailFormComponent,
    RouterModule,
  ],
  templateUrl: './schedule-service.component.html',
  styleUrl: './schedule-service.component.scss',
})
export class ScheduleServiceComponent implements OnInit {
  private cleanupZoomListener: () => void = () => {};
  pageReady = false;
  scheduleServiceForm: FormGroup;
  aglHolidayList: any;
  startDate: any;
  today = new Date();
  maxDate: any;
  isBrowser = false;
  standardFormErrorMessage = '';
  pageName = 'Schedule Service';
  pageLabels: any;
  process = 'start';
  step = 2;
  ssmData: SSMProcessData = new SSMProcessData();
  pageHeader = new PageHeader();
  userProfile: UserProfile = new UserProfile();
  hasEmail = false;
  emailFormData: any = {};
  accountDetail: AccountDetail = new AccountDetail();
  userName = '';

  constructor(
    private readonly utils: UtilService,
    private readonly fb: FormBuilder,
    private readonly cal: CalendarService,
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(PLATFORM_ID) readonly platformId: Object,
    private readonly storage: StorageService,
    private readonly notifi: NotificationsService,
    private readonly cms: CmsService,
    private readonly router: Router,
    private readonly seoS: SeoService,
    private readonly account: AccountService,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    if (this.isBrowser) {
      this.standardFormErrorMessage = this.storage.getSession(StorageEnum.GlobalVars).formError;
      this.ssmData = this.storage.getSession(StorageEnum.SSMData);
      this.userProfile = this.storage.getSession(StorageEnum.LoginResponse);
      this.accountDetail = this.storage.getSession(StorageEnum.AccountDetail);
      this.userName = this.storage.getSession(StorageEnum.UserName);
    }
    if (!this.utils.isNullOrUndefined(this.ssmData)) {
      if (this.ssmData.CurrentProcess === 'move') {
        this.process = 'move';
        this.step = 3;
      }
      if (this.ssmData.CurrentProcess === 'reconnect') {
        this.process = 'reconnect';
        this.step = 1;
      }
    } else {
      this.process = 'reconnect';
      this.step = 1;
      this.ssmData = new SSMProcessData();
      this.ssmData.CurrentProcess = 'reconnect';
      this.ssmData.StartRequest = new StartServiceRequest();
    }

    this.scheduleServiceForm = this.fb.group({
      ServiceOption: ['', Validators.required],
      DateOption: '',
      Date: '',
      TimeOption: '',
      Saturday: false,
      Provider: '',
    });
    this.cal.getAGLHolidayList().subscribe({
      error: (e) => {
        this.aglHolidayList = '';
      },
      next: (data: any) => {
        this.aglHolidayList = data;
      },
    });
    this.startDate = addDays(this.today, 3);
    this.maxDate = addDays(this.today, 90);
  }

  ngOnInit(): void {
    this.getPersonData()
      .pipe(
        concatMap((data: any) => {
          if (data !== 'not reconnect') {
            this.accountDetail.Person = data;
          }
          return this.cms.getContent('oas-schedule-service', 'Schedule Service');
        }),
      )
      .subscribe((data: any) => {
        this.pageLabels = data;
        this.pageHeader.Message =
          this.ssmData.CurrentProcess === 'start'
            ? this.pageLabels.startHeadlineHeader
            : this.pageLabels.headlineHeader;
        this.seoS.setSeoTags(data.seo);
        this.hasEmail =
          this.accountDetail?.Person?.EmailAddresses?.find((email: EmailInfo) => {
            return email.IsPrimary && email.Type?.toUpperCase() === 'EMAIL';
          })?.IsPrimary ?? false;
        if (!this.hasEmail) {
          this.setupEmailData();
        }
        this.pageReady = true;

        if (this.isBrowser) {
          this.scheduleServiceForm.get('ServiceOption')?.valueChanges.subscribe((val) => {
            this.notifi.clearAllNotifications();
            const startDateChoice = this.scheduleServiceForm.get('DateOption');
            const providerChoice = this.scheduleServiceForm.get('Provider');
            const dateChoice = this.scheduleServiceForm.get('Date');
            const timeChoice = this.scheduleServiceForm.get('TimeOption');
            if (val === 'turn-on') {
              startDateChoice?.setValidators([Validators.required]);
              providerChoice?.clearValidators();
            } else {
              startDateChoice?.clearValidators();
              startDateChoice?.reset();
              providerChoice?.setValidators([Validators.required]);
              dateChoice?.clearValidators();
              timeChoice?.clearValidators();
              dateChoice?.markAsPristine();
              timeChoice?.markAsPristine();
              dateChoice?.updateValueAndValidity();
              timeChoice?.updateValueAndValidity();
              dateChoice?.reset();
              timeChoice?.reset();
            }
            startDateChoice?.updateValueAndValidity();
            providerChoice?.updateValueAndValidity();
          });
          this.scheduleServiceForm.get('DateOption')?.valueChanges.subscribe((val) => {
            this.notifi.clearAllNotifications();
            const dateChoice = this.scheduleServiceForm.get('Date');
            const timeChoice = this.scheduleServiceForm.get('TimeOption');
            if (val === 'choose') {
              dateChoice?.setValidators([Validators.required]);
              timeChoice?.setValidators([Validators.required]);
            } else {
              dateChoice?.clearValidators();
              timeChoice?.clearValidators();
            }
            dateChoice?.updateValueAndValidity();
            timeChoice?.updateValueAndValidity();
          });
          if (this.process !== 'start') {
            this.scheduleServiceForm.get('ServiceOption')?.setValue('turn-on');
          }
          if (
            !this.utils.isNullOrUndefined(this.ssmData) &&
            !this.utils.isNullOrUndefined(this.ssmData.FirstAvailable)
          ) {
            // if this field is not null or undefined, that means the user has come back to this page from later in the process and we need to and we need to prepopulate the data
            if (this.ssmData.FirstAvailable) {
              this.scheduleServiceForm.get('DateOption')?.setValue('first');
            } else {
              this.scheduleServiceForm.get('DateOption')?.setValue('choose');
              this.scheduleServiceForm.get('Date')?.setValue(this.ssmData.Date);
              this.scheduleServiceForm.get('TimeOption')?.setValue(this.ssmData.Time);
            }
          }
        }
        this.utils.hideSpinner();
      });
  }

  onDatepickerOpened(picker: MatDatepicker<Date>): void {
    this.cleanupZoomListener = this.utils.attachDatepickerZoomListener(picker);
  }

  onDatepickerClosed(): void {
    this.cleanupZoomListener();
  }

  dateFilter = (d: Date | null): boolean => {
    // disable dates that are weekend or AGL holiday
    const innerDate = d ?? new Date();
    return innerDate.getDay() !== 0 && innerDate.getDay() !== 6 && !this.dayIsAglHoliday(innerDate);
  };

  dayIsAglHoliday(d: Date): boolean {
    const filteredArray = this.aglHolidayList.filter((holiday: any) => {
      return (
        holiday.Day === d.getDate().toString() &&
        holiday.Month === (d.getMonth() + 1).toString() &&
        holiday.Year === d.getFullYear().toString()
      );
    });
    return filteredArray.length > 0;
  }

  handleSubmitButtonPress(): void {
    this.utils.showSpinner();
    this.notifi.clearAllNotifications();
    if (!this.hasEmail) {
      // handle new email stuff
      if (this.emailFormData.formGroup.valid) {
        const emailValue = this.emailFormData.formGroup.value.email;

        const personRequest = this.accountDetail?.Person;
        if (personRequest?.FirstName === null) {
          personRequest.FirstName = this.accountDetail.FirstName !== null ? this.accountDetail.FirstName : '';
        }
        if (personRequest?.LastName === null) {
          personRequest.LastName = this.accountDetail.LastName !== null ? this.accountDetail.LastName : '';
        }
        const email = new EmailInfo();
        email.ContactId = '';
        email.Email = emailValue;
        email.IsActive = true;
        email.IsPrimary = true;
        email.Type = 'EMAIL';
        personRequest?.EmailAddresses?.push(email);
        this.account.UpdatePersonContact(personRequest).subscribe({
          error: (e) => {
            this.utils.consoleLog('There was an error adding email on stop service page. Error: ' + e);
            this.utils.hideSpinner();
          },
          next: (data: any) => {
            this.accountDetail.Person = data;
            this.storage.setSession(StorageEnum.AccountDetail, this.accountDetail);
            this.hasEmail = true;
            this.handleScheduleServiceData();
          },
        });
      } else {
        this.emailFormData.formGroup.markAllAsTouched();
        this.notifi.addNotification(this.standardFormErrorMessage, NotificationType.Alert, this.pageName);
        this.utils.hideSpinner();
      }
    } else {
      this.handleScheduleServiceData();
    }
  }

  handleScheduleServiceData(): void {
    if (this.scheduleServiceForm.valid) {
      // do stuff
      this.utils.hideSpinner();
      if (this.scheduleServiceForm.get('ServiceOption')?.value === 'switch') {
        if (this.ssmData.StartRequest !== undefined) {
          this.ssmData.StartRequest.StartServiceType = 'MKSW';
        }
      } else {
        if (this.ssmData.StartRequest !== undefined) {
          this.ssmData.StartRequest.StartServiceType = 'TO';
        }
        if (this.scheduleServiceForm.get('DateOption')?.value === 'choose') {
          this.ssmData.FirstAvailable = false;
          this.ssmData.Date = format(this.scheduleServiceForm.get('Date')?.value, 'MM/dd/yyyy');
          this.ssmData.Time = this.scheduleServiceForm.get('TimeOption')?.value;
          this.ssmData.SaturdayIfAvailable = this.scheduleServiceForm.get('Saturday')?.value;
        } else {
          this.ssmData.FirstAvailable = true;
        }
      }
      if (this.ssmData?.CurrentProcess === 'reconnect') {
        let premiseIdReq = new ServiceAddress();
        if (this.userProfile.Accounts[0].NumAgreements === 1) {
          premiseIdReq.Address1 = this.userProfile.Accounts[0].ServiceAddresses[0].Address1;
          premiseIdReq.Address2 = this.userProfile.Accounts[0].ServiceAddresses[0].Address2;
          premiseIdReq.City = this.userProfile.Accounts[0].ServiceAddresses[0].City;
          premiseIdReq.State = this.userProfile.Accounts[0].ServiceAddresses[0].State;
          premiseIdReq.PostalCode = this.userProfile.Accounts[0].ServiceAddresses[0].PostalCode;
          premiseIdReq.SaId = this.userProfile.Accounts[0].ServiceAddresses[0].SaId;
          if (this.ssmData.StartRequest === undefined) {
            this.ssmData.StartRequest = new StartServiceRequest();
          }
          this.ssmData.StartServiceAddress = this.userProfile.Accounts[0].ServiceAddresses[0];
          this.ssmData.StartRequest.Address1 = premiseIdReq.Address1;
          this.ssmData.StartRequest.City = premiseIdReq.City;
          this.ssmData.StartRequest.State = premiseIdReq.State;
          this.ssmData.StartRequest.ZipCode = premiseIdReq.PostalCode;
          // map start request address fields ore premiseIdReq address fields
        } else {
          premiseIdReq = this.storage.getSession(StorageEnum.SelectedSA);
        }
        this.ssmData.UseServiceAddressAsMailingAddress = true;
      }
      this.storage.setSession(StorageEnum.SSMData, this.ssmData);
      if (this.ssmData?.CurrentProcess === 'reconnect') {
        void this.router.navigateByUrl(Nav.ReconnectRates);
      } else if (this.ssmData?.CurrentProcess === 'start') {
        void this.router.navigateByUrl(Nav.StartServiceChooseRates);
      } else {
        void this.router.navigateByUrl(Nav.MoveServiceChooseRates);
      }
    } else {
      this.scheduleServiceForm.markAllAsTouched();
      this.notifi.addNotification(this.standardFormErrorMessage, NotificationType.Alert, this.pageName);
      this.utils.hideSpinner();
    }
  }

  setupEmailData(): void {
    this.emailFormData.showConfirmEmail = true;
    this.emailFormData.formGroup = this.fb.group({
      email: ['', [Validators.required, emailValidator()]],
      emailConfirm: ['', [Validators.required, emailValidator()]],
    });
  }

  getPersonData(): Observable<any> {
    if (this.utils.isNullOrUndefined(this.accountDetail.Person)) {
      const personReq = {
        AccountNumber: this.accountDetail.AccountNumber,
        UserName: this.accountDetail.PrimaryAccountHolder === true ? this.userName : '',
        PersonId: this.accountDetail.PersonId,
      };
      return this.account.GetPerson(personReq);
    } else {
      return of('not reconnect');
    }
  }

  goBack(): string {
    if (this.ssmData.CurrentProcess === 'start') {
      return Nav.StartServiceAddress;
    } else {
      return Nav.MoveServiceAddress;
    }
  }
}
